export enum DOCUMENT_ID {
  W9 = '10',
  W9_JOINT = '1010',
}

export const DOCUMENTS_W9: DOCUMENT_ID[] = [DOCUMENT_ID.W9, DOCUMENT_ID.W9_JOINT];
